// removed by extract-text-webpack-plugin
module.exports = {"Payouts":"_1vPv4MNxix0Evf7esjOhtI","MainColumn":"_1Mobt5oG_1MV5C8Puw51I","SideColumn":"_122RdD5mb4Qc91P7YzhdH4"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfAdministrator/Payouts/styles.module.css
// module id = 612
// module chunks = 0